// TO-DO: i18n
export default {
  1: [
    {
      name: 'Image',
      field: 'src',
      type: 'imageUrl',
      width: '20%'
    },
    {
      name: 'Altanative Text',
      field: 'alt'
    }// ,
    // {
    //   name: 'OCR',
    //   field: 'ocrText'
    // }
  ],
  2: [
    {
      name: 'Figcaption',
      field: 'text'
    }
  ],
  3: [
    {
      name: 'TH content',
      field: 'text'
    },
    {
      name: 'Scrope attribute',
      field: 'scope'
    }
  ],
  4: [
    {
      name: 'Skip navigation Link name',
      field: 'text',
      width: '35%'
    },
    {
      name: 'Hypertext reference (href)',
      field: 'href'
    }
  ],
  5: [
    {
      name: 'Link information',
      field: 'text',
      width: '20%'
    },
    {
      name: 'Hypertext reference (href)',
      field: 'href',
      array: true
    },
    {
      name: 'Destination',
      field: 'link',
      array: true
    }
  ],
  6: [
    {
      name: 'Heading level',
      field: 'level'
    },
    {
      name: 'Heading content',
      field: 'text',
      width: '20%'
    }
  ],
  7: [
    {
      name: 'Media',
      field: 'tagName',
      type: 'tagName'
    }
  ],
  8: [
    {
      name: 'Tag name',
      field: 'tagName',
      type: 'tagName'
    },
    {
      name: 'Content',
      field: 'text',
      width: '20%'
    }
  ],
  9: [
    {
      name: 'Form element',
      field: 'tagName',
      type: 'tagName'
    },
    {
      name: 'Label',
      value: '-',
      type: 'static'
    },
    {
      name: 'Title attribute',
      field: 'title'
    }
  ],
  10: [
    {
      name: 'Form element',
      field: 'tagName',
      type: 'tagName'
    },
    {
      name: 'Label',
      field: 'label'
    },
    {
      name: 'Label code',
      field: 'subId',
      type: 'code',
      array: true
    }
  ],
  11: [
    {
      name: 'Id attribute',
      field: 'domId'
    },
    {
      name: 'code',
      field: 'subId',
      type: 'code',
      array: true
    }
  ],
  12: [
    {
      name: 'Lang',
      field: 'lang'
    }
  ],
  13: [
    {
      name: 'Content',
      field: 'text',
      type: 'text',
      width: '80%'
    },
    {
      name: 'Color ratio',
      field: 'ratio',
      type: 'ratio',
      width: '280px'
    }
  ],
  14: [
    {
      name: 'Content',
      field: 'text'
    }
  ],
  16: [
    {
      name: 'Frame title',
      field: 'text'
    }
  ],
  17: [
    {
      name: 'Table caption',
      field: 'captionId',
      type: 'code'
    }
  ],
  19: [
    {
      name: 'Page title',
      field: 'text'
    }
  ],
  21: [
    {
      name: 'Link information',
      field: 'text'
    }
  ],
  22: [
    {
      name: 'Skip navigation',
      value: 'Need to check',
      type: 'static'
    }
  ],
  23: [
    {
      name: 'Heading element',
      value: 'Need to check',
      type: 'static'
    }
  ],
  24: [
    {
      name: 'Image',
      field: 'src',
      type: 'imageUrl',
      width: '20%',
      rowspan: true
    }// ,
    // {
    //   name: 'Text',
    //   field: 'ocrText',
    //   type: 'ocrText',
    //   array: true
    // },
    // {
    //   name: 'Color ratio',
    //   field: 'ocrRatio',
    //   type: 'ratio',
    //   width: '280px',
    //   array: true
    // }
  ],
  25: [
    {
      name: 'Image',
      field: 'filename',
      type: 's3Image',
      width: '20%'
    },
    {
      name: 'Alternative text',
      field: 'alt'
    },
    {
      name: 'Copy text',
      field: 'copy'
    },
    {
      name: 'OCR',
      field: 'ocrText'
    }
  ],
  26: [
    {
      name: 'Tag name',
      field: 'tagName',
      type: 'tagName'
    },
    {
      name: 'Field type',
      field: 'fieldType'
    },
    {
      name: 'Auto complete',
      field: 'autocomplete'
    }
  ],
  27: [
    {
      name: 'Tag name',
      field: 'tagName',
      type: 'tagName'
    }
  ],
  28: [
    {
      name: 'Tag name',
      field: 'tagName',
      type: 'tagName'
    },
    {
      name: 'Label text',
      field: 'labelText'
    },
    {
      name: 'Visible text',
      field: 'visibleText'
    }
  ],
  29: [
    {
      name: 'Url',
      field: 'url'
    },
    {
      name: 'Code',
      field: 'code',
      type: 'match'
    }
  ],
  30: [
    {
      name: 'Image',
      field: 'filename',
      type: 's3Image',
      width: '20%',
      rowspan: true
    },
    {
      name: 'Text',
      field: 'ocrText',
      type: 'ocrText',
      array: true
    },
    {
      name: 'Color ratio',
      field: 'ocrRatio',
      type: 'ratio',
      width: '280px',
      array: true
    }
  ],
  31: [
    {
      name: 'Destination',
      field: 'link'
    },
    {
      name: 'Link information',
      field: 'text',
      width: '20%',
      array: true
    },
    {
      name: 'Hypertext reference (href)',
      field: 'href',
      array: true
    }
  ],
  99: [
    {
      name: 'Code',
      field: 'code',
      type: 'code'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/data/rule-ui-type.js